import axios from "axios";

const API = "";

// Axios client that uses MYIHTP session cookie (ihtp_my_access_token)
// to hit /api/push/* directly.
const pushApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default pushApi;
